import type { MailboxInfo } from 'owa-client-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import { isPoliciesEnabledForAccount } from '../utils/isPoliciesEnabledForAccount';
import { getPolicyDataBySettingId } from './getPolicyDataBySettingId';

export function isOcpsPolicyEnabled(
    settingId: OutlookCloudPolicySettingId,
    mailboxInfo?: MailboxInfo,
    enabledIfUndefined?: boolean
): boolean {
    const resolvedMailboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();
    if (!isPoliciesEnabledForAccount(resolvedMailboxInfo)) {
        return enabledIfUndefined ?? true;
    }
    const policyData = getPolicyDataBySettingId(resolvedMailboxInfo, settingId);
    return policyData ? policyData.value === '1' : enabledIfUndefined ?? false;
}
